export const Alumni = [
  {
    name: "Rohit Kumawat",
    currentEmployer: "IIT Roorkee",
  },
  {
    name: "Sriharsha Bulusu",
    currentEmployer: "Webstaff, Japan",
  },
  {
    name: "Vimal",
    currentEmployer: "",
  },
  {
    name: "Pintesh",
    currentEmployer: "",
  },
];
